module.exports = __webpack_public_path__ + "static/media/depressed-person-sitting-svgrepo-com.0e3c53a2.svg";